import { render, staticRenderFns } from "./EmployeeInformation.vue?vue&type=template&id=b7224298&scoped=true"
import script from "./EmployeeInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7224298",
  null
  
)

export default component.exports